import { useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import { getCookie } from '@/src/utils/browser'
import { useLocale } from 'next-intl'
import { useRouter } from 'next/navigation'
import useGetItineraryId from '../../itinerary/useGetItineraryId'

const useRedirectToSrp = () => {
    const itineraryId = useGetItineraryId()
    const locale = useLocale()
    const { searchCriteria, flights } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            selectFromResult: ({ data }) => ({
                searchCriteria: data?.searchCriteria,
                flights: data?.flights
            })
        }
    )
    const router = useRouter()

    function dataConvert(date: string) {
        let dataSplit = date.split('T')[0]
        const dataParse = dataSplit.split('-')
        return `${dataParse[2]}/${dataParse[1]}/${dataParse[0]}`
    }

    const redirectToSrp = () => {
        const {
            paxInfo: { adults = '', children = '', infants = '' } = {},
            departDate = '',
            arrivalDate = '',
            from = '',
            to = '',
            sft
        } = searchCriteria || {}
        let cabinType = 'Economy'
        if (Array.isArray(flights)) {
            flights.forEach(flight => {
                const { segments = [] } = flight || []
                segments?.forEach(segment => {
                    if (typeof segment.cabinType === 'string') {
                        cabinType = segment.cabinType
                            .split(' ')
                            .map(item => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase())
                            .join('')
                    } else {
                        cabinType = segment.cabinType
                    }
                })
            })
        }
        const pathname = `/${locale}/flights/results`
        let destinationHeader = ''
        let sourceHeader = ''
        if (typeof document != 'undefined' && getCookie('fsHistoryMobile')) {
            const fsHistory = JSON.parse(getCookie('fsHistoryMobile') || '{}')
            destinationHeader = fsHistory.destinationHeader || ''
            sourceHeader = fsHistory.sourceHeader || ''
        }

        // Construct query parameters
        const queryParams = new URLSearchParams({
            class: cabinType,
            from: from,
            to: to,
            depart_date: dataConvert(departDate),
            return_date: arrivalDate ? dataConvert(arrivalDate) : '',
            adults: adults.toString(),
            childs: children.toString(),
            infants: infants.toString(),
            sft: sft || '',
            destinationHeader,
            sourceHeader
        })

        // Remove empty values from query string
        for (const [key, value] of Array.from(queryParams.entries())) {
            if (!value) {
                queryParams.delete(key)
            }
        }

        const fullUrl = `${pathname}?${queryParams.toString()}`
        router.replace(fullUrl)
    }

    return redirectToSrp
}

export default useRedirectToSrp
